"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var csp_actions_1 = require("../components/discovery/csp/csp_actions");
var categories_store_1 = require("../components/discovery/stores/categories_store");
var categories_actions_1 = require("../components/discovery/actions/categories_actions");
var lodash_1 = require("lodash");
function buildParams(state) {
    return tslib_1.__assign(tslib_1.__assign({}, lodash_1.get(state, 'location.query') || {}), lodash_1.get(state, 'params') || {});
}
exports.default = {
    fetchCSPs: function (newState, oldState) {
        if (oldState === void 0) { oldState = {}; }
        var oldParams = buildParams(oldState);
        var newParams = buildParams(newState);
        if (lodash_1.isEqual(oldParams, newParams)) {
            return;
        }
        var requestParams = tslib_1.__assign(tslib_1.__assign({}, newParams), { page: newParams.page || 1, per_page: 30, sort: 'title', featured: true });
        csp_actions_1.default.fetch(requestParams);
    },
    fetchCategories: function () {
        var currentState = categories_store_1.default.getState();
        if (!currentState.categories.length) {
            categories_actions_1.default.fetch();
        }
    },
};
//# sourceMappingURL=csp_grid_data_manager.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/data_managers/csp_grid_data_manager.js
// module id = BX25
// module chunks = 20 21